<script lang="ts">
  import type { GameState } from '@rsvjelle/game-core';
  import type { AccountSummary } from '../lib/account-status.ts';
  import { formatNumber } from '../lib/display.ts';
  import RealmLogo from './RealmLogo.svelte';
  interface Props { state: GameState; account: AccountSummary; onOpenAccount: () => void }
  let { state, account, onOpenAccount }: Props = $props();
  let totalLevel = $derived(Object.values(state.run.skills).reduce((sum, skill) => sum + skill.level, 0));
  let accountLabel = $derived(
    account.status === 'synced' ? `Cloud synced · ${account.username}`
      : account.status === 'attention' ? 'Account needs attention'
        : account.status === 'checking' ? 'Checking account…'
          : 'Local only · protect progress'
  );
</script>

<header class="game-header">
  <div class="brand-lockup">
    <RealmLogo />
    <div>
      <p class="eyebrow">RSVJELLE</p>
      <h1>Idle Realm <span>II</span></h1>
    </div>
  </div>
  <div class="header-stats">
    <div><span>Total level</span><strong>{formatNumber(totalLevel, 0)}</strong></div>
    <div><span>Gold</span><strong class="gold">● {formatNumber(state.run.gold)}</strong></div>
    <button class:online={account.status === 'synced'} class:attention={account.status === 'attention'} class="save-pill" type="button" onclick={onOpenAccount} aria-label={`${accountLabel}. Open account settings.`}><i></i>{accountLabel}</button>
  </div>
</header>
